import { z } from 'zod';
import { IsoTimestampSchema, UuidSchema } from './primitives.js';
import { WebhookSourceSchema } from './enums.js';
/**
 * Inbound webhook event from Swan or Sumsub.
 *
 * ⚠️ COMPLIANCE: the `(source, external_id)` pair MUST be UNIQUE in DB.
 * That uniqueness constraint is what gives us idempotency — re-delivered
 * webhooks become no-ops instead of duplicating effects. See CLAUDE.md §6.
 *
 * The full payload is intentionally NOT in this Zod schema for routes that
 * return webhook info to users — we never expose raw provider payloads.
 */
export const WebhookEventSchema = z.object({
    id: UuidSchema,
    source: WebhookSourceSchema,
    external_id: z.string().min(1),
    type: z.string().min(1),
    signature_valid: z.boolean(),
    processed_at: IsoTimestampSchema.nullable(),
    error: z.string().nullable(),
    created_at: IsoTimestampSchema,
});
//# sourceMappingURL=webhook.js.map